import { ACCOUNTING_DAY_ROUTING } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeAccountingDayRouting } from "lib/serializers/accountingDayRouting";

export default apiModelOfflineFetchReducer(ACCOUNTING_DAY_ROUTING, {
  deserializer: deserializeAccountingDayRouting,
  clearOnRequest: true,
});
